import { Calendar } from '../_components';
import { CalendarConstants } from '../_constants';

const initialState = {
  loading: false,
  params: undefined,
  error: undefined,
  items: [],
};

export function calendars(state = initialState, action) {
  switch (action.type) {
    case CalendarConstants.FETCH_BY_ID_REQUEST: {
      return {
        ...state,
        loading: true,
        error: undefined,
        params: action.params,
      };
    }

    case CalendarConstants.FETCH_BY_ID_SUCCESS: {
      const { payload } = action;
      const oldItemIndex = state.items.findIndex((i) => i._id === payload._id);
      let newItems = [];
      if (oldItemIndex && oldItemIndex > -1) {
        newItems = [
          state.items.slice(0, oldItemIndex),
          payload,
          state.items.slice(oldItemIndex + 1),
        ];
      } else {
        newItems = [...state.items, payload];
      }
      return {
        ...state,
        loading: false,
        error: undefined,
        params: undefined,
        items: newItems,
      };
    }

    case CalendarConstants.FETCH_BY_ID_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        params: undefined,
        error,
      };
    }

    case CalendarConstants.CREATE_NEW_REQUEST: {
      const { params } = action;
      return {
        ...state,
        loading: true,
        error: undefined,
        params,
      };
    }

    case CalendarConstants.CREATE_NEW_SUCCESS: {
      const { payload } = action;
      const newItems = [...state.items, payload];
      return {
        ...state,
        loading: false,
        error: undefined,
        params: undefined,
        items: newItems,
      };
    }
    case CalendarConstants.CREATE_NEW_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        params: undefined,
        error,
      };
    }

    case CalendarConstants.UPDATE_REQUEST: {
      const { params } = action;
      return {
        ...state,
        loading: true,
        error: undefined,
        params,
      };
    }
    case CalendarConstants.UPDATE_SUCCESS: {
      const { payload } = action;
      const oldItemIndex = state.items.find((i) => i._id === payload._id);
      let newItems = [];
      if (oldItemIndex && oldItemIndex > -1) {
        newItems = [
          ...state.items.slice(0, oldItemIndex),
          payload,
          ...state.items.slice(oldItemIndex + 1),
        ];
      } else {
        newItems = [...state.items, payload];
      }
      return {
        ...state,
        loading: false,
        params: undefined,
        error: undefined,
        items: newItems,
      };
    }
    case CalendarConstants.UPDATE_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        params: undefined,
        error,
      };
    }
    case CalendarConstants.DELETE_REQUEST: {
      const { params } = action;
      return {
        ...state,
        loading: true,
        error: undefined,
        params,
      };
    }
    case CalendarConstants.DELETE_SUCCESS: {
      const { payload } = action;
      const oldItemIndex = state.items.find((i) => i._id === payload);
      const newItems = [
        ...state.items.slice(0, oldItemIndex),
        ...state.items.slice(oldItemIndex + 1),
      ];

      return {
        ...state,
        loading: false,
        error: undefined,
        params: undefined,
        items: newItems,
      };
    }
    case CalendarConstants.DELETE_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        params: undefined,
        error,
      };
    }

    default:
      return state;
  }
}
